import { render, staticRenderFns } from "./BannerFormUpdate.vue?vue&type=template&id=207bacd8&scoped=true&"
import script from "./BannerFormUpdate.vue?vue&type=script&lang=js&"
export * from "./BannerFormUpdate.vue?vue&type=script&lang=js&"
import style0 from "./BannerFormUpdate.vue?vue&type=style&index=0&id=207bacd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207bacd8",
  null
  
)

export default component.exports